import { defineMessages } from "react-intl";

import {
	hcvScreeningMessages,
	validator
} from "lib/build/forms/htx/microbiological-procedures/hcv";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	hcv: {
		id: "form.hcv",
		defaultMessage: "HCV"
	},
	hcvScreening: {
		id: "form.hcv.hcv_screening",
		defaultMessage: "HCV szűrés"
	}
});

const fields: { [key: string]: FieldData } = {
	hcvScreening: {
		type: "field",
		path: ["hcvScreening"],
		label: messages.hcvScreening,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: hcvScreeningMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.hcvScreening }] }]
};

export const node: LeafNode = {
	id: "hcv",
	value: {
		title: messages.hcv,
		validator,
		fieldset,
		isImportant: true
	}
};
